import {
    CreateAppointmentInterface,
    UpdateAppointmentInterface,
} from '../../types/appointment';
import { getRequest, postRequest, putRequest } from '../client';

export const fetchAppointments = async () => {
    const data = await getRequest<any[]>('api/appointment/unclosed');

    return data;
};

export const postAppointment = async (
    createAppointment: CreateAppointmentInterface
) => {
    const data = await postRequest<any>('api/appointment', createAppointment);

    return data;
};

export const putAppointment = async (
    appointmentId: number,
    updatedAppointment: UpdateAppointmentInterface
) => {
    const data = await putRequest<any>(
        `api/appointment/${appointmentId}`,
        updatedAppointment
    );

    return data;
};
